import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './TonicQuiz.css';
import { useSelector } from 'react-redux';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const TonicQuiz = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [selectedSetId, setSelectedSetId] = useState('');
    const [tonicSetMasterList, setSetMasterList] = useState([]);
    const [tonicAnsweredSetList, setTonicAnsweredSetList] = useState([]);
    const [selectedTonicAnsweredSetId, setSelectedTonicAnsweredSetId] = useState('');

    const [tonicAnsweredMaster, setAnsweredMaster] = useState([]);
    const [tonic, setTonic] = useState('');
    const [tonicQueryTitle, setTonicQueryTitle] = useState('');

    const [tonicHead, setTonicHead] = useState('');
    const tonicInitialized = useRef(false);

    const tonicRoutesMap = {
        "tonic-football": "Football",
        "tonic-cricket": "Cricket",
        "tonic-chemistry": "Chemistry",
        "tonic-cafe": "CAFE",
        "tonic-sports": "Sports",
        "tonic-family": "Family",
        "tonic-spiritual108": "Spiritual108",
        "tonic-programmer": "Programmer",
        "tonic-maths": "Maths",
        "tonic-science": "Science",
        "tonic-commerce": "Commerce",
        "tonic-management": "Management",
        "tonic-entertainment": "Entertainment",
        "tonic-public": "Public",
        "tonic-defence": "Defence",
        "tonic-beat": "BEAT",
        "tonic-coat": "COAT",
        "tonic-school": "School",
        "tonic-college": "College",
        "tonic-university": "University",
        "tonic-tutorials": "Tutorials",
        "tonic-medical": "Medcial",
        "tonic-engineering": "Engineering",
        "tonic-ca": "CA",
        "tonic-law": "Law",
        "tonic-jee": "JEE",
        "tonic-neet": "NEET",
        "tonic-toefl": "TOEFL",
        "tonic-ugcnet": "UGCNET",
      };

    useEffect(() => {
        document.title = authState.isLoggedIn
        ? `${authState.user.name}'s Tonic`
        : "Think5Whys";
    }, [authState]);

    useEffect(() => {
        if (!tonicInitialized.current) {
        const tonicRoute = location.pathname.split("/").pop();
        const newTonicQueryTitle = tonicRoutesMap[tonicRoute] || "Public";
        setTonicQueryTitle(newTonicQueryTitle);
        setTonicHead(newTonicQueryTitle);
        tonicInitialized.current = true;
        fetchTonicAnsweredSetList(newTonicQueryTitle);
        }
    }, [location.pathname]);

    // Fetch today's tonic set masters
    const fetchTodayTonicSetMasters = useCallback(() => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const localDate = new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000));
        const formattedDate = localDate.toISOString().split('T')[0];

        const config = {
        url: "/tonicsetmaster/todaylist",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
            userId: authState.user._id,
            tonic: tonicQueryTitle,
            date: formattedDate,
        },
        };
        fetchData(config, { showSuccessToast: false })
        .then((response) => {
            if (response && Array.isArray(response.tonicSetMasterList)) {
            setSetMasterList(response.tonicSetMasterList);
            } else {
            console.error(
                "Invalid response format: Set master list not found in response"
            );
            }
        })
        .catch((error) => {
            console.error("Error fetching set masters:", error);
        });
    }, [authState.token, authState.user._id, tonicQueryTitle, fetchData]);

    useEffect(() => {
        if (authState.isLoggedIn) {
        fetchTodayTonicSetMasters();
        }
    }, [authState.isLoggedIn, fetchTodayTonicSetMasters]);


    //MyTonicAnsweredSetList
    const fetchTonicAnsweredSetList = useCallback((newTonicQueryTitle) => {
        const config = {
            url: "/mytonicansweredsets/mysets",
            method: "post",
            headers: { Authorization: authState.token},
            data: { userId: authState.user._id, tonicName: newTonicQueryTitle}
        };
                // console.log("config:", config);

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Answered Set List Response:", response);
                if (response && Array.isArray(response.TonicAnswersdSetlist)) {
                    setTonicAnsweredSetList(response.TonicAnswersdSetlist);
                } else {
                    console.error("Invalid response format: Tonic Answer set list not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Tonic Answer list:", error);
            });
    }, [authState.token, fetchData]);

    // useEffect(() => {
    //     fetchTonicAnsweredSetList();
    // }, [fetchTonicAnsweredSetList]);

    const sortedTonicSetMasterList = [...tonicSetMasterList].sort((a, b) => a.setDisplaySn - b.setDisplaySn);
    const sortedTonicAnsweredSetList = [...tonicAnsweredSetList].sort((a, b) => new Date(b.dateAnswered) - new Date(a.dateAnswered));

    useEffect(() => {
        let newAnsweredMaster = [];
        sortedTonicAnsweredSetList.forEach(answeredSet => {
            const matchingSetMaster = sortedTonicSetMasterList.find(setMaster => setMaster._id === answeredSet.setId);
            if (matchingSetMaster) {
                newAnsweredMaster.push(matchingSetMaster);
            }
        });
        setAnsweredMaster(newAnsweredMaster);
    }, [sortedTonicSetMasterList, sortedTonicAnsweredSetList]);


    const handleTonicSetMasterView = (setId) => {
        setSelectedSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleTonicAnsweredSetView = (setId) => {
        setSelectedTonicAnsweredSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleTonicAnswerClick = (setId, setTitle, timeLimitInMin) => {
        navigate('/tonic-test-answer', { state: { setId: setId, setTitle: setTitle, tonicTitle: tonicQueryTitle, timeLimitInMin: timeLimitInMin} });
    };

    function convertTimeLimit(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const formattedTimeLimit = `${hours}:${remainingMinutes} (Hr:Min)`;
        return formattedTimeLimit;
    }

    function convertTimeTaken(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const remainingMinutes = Math.floor((milliseconds % 3600000) / 60000);
        const remainingSeconds = Math.floor((milliseconds % 60000) / 1000);
        const remainingMilliseconds = milliseconds % 1000;
        const formattedTime = `${hours}:${remainingMinutes
            .toString()
            .padStart(2, "0")}:${remainingSeconds
                .toString()
                .padStart(2, "0")}.${remainingMilliseconds
                    .toString()
                    .padStart(3, "0")} (Hr:Min:Sec)`;
        return formattedTime;
    }

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };


    return (
        <div className='bg-black text-white [&_p]:text-white'>
            <div>
                <h3 className='text-xl font-bold text-white text-center mb-2'>Today's Think5Whys {tonicQueryTitle} Tonic</h3>
                <p className='text-sm font-bold text-yellow-300 text-center mb-2'>Once you click <strong>Start</strong> and view the Questions screen, it will be considered as participation in the quiz, even if you choose not to answer and exit. Please complete answering the questions.</p>
                <div className="border border-gray-300 p-4 mt-4">
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="ml-4">
                            <div>
                                {tonicSetMasterList && tonicSetMasterList.length === 0 ? (
                                    <div className='w-full flex items-center justify-center text-yellow-300 mb-4 text-xl'>
                                        No Set Found for Today's {tonicQueryTitle} Tonic!
                                    </div>
                                ) : (
                                    sortedTonicSetMasterList.map((setMaster, index) => (
                                        <div key={setMaster._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md flex flex-col'>
                                            <div className='flex flex-row '>    
                                                <div className='mt-2 text-sm'>
                                                    <span className={tonicAnsweredMaster.some(practiced => practiced._id === setMaster._id) ? 'font-medium text-yellow-500 px-2 py-1' : 'font-medium px-2 py-1'}>
                                                        {index + 1}. {setMaster.setTitle}
                                                    </span>
                                                    <span>
                                                        Target Participants: {setMaster.setGrade}
                                                    </span>
                                                </div>
                                                <div className='mt-2'>
                                                    <Tooltip text={"View details"} position={"top"}>
                                                        <span className='ml-4 px-2 py-1 text-blue-500 cursor-pointer' onClick={() => handleTonicSetMasterView(setMaster._id)}>
                                                            <i className="fa-solid fa-eye"></i>
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                                <div className='mt-2'>
                                                    <button
                                                            className={`mt-2 ml-4 px-2 py-1 text-white rounded${tonicAnsweredMaster.find(item => item._id === setMaster._id) ? ' bg-blue-500' : ' bg-green-500'}`}
                                                            onClick={() => handleTonicAnswerClick(setMaster._id, setMaster.setTitle, setMaster.timeLimitInMin, tonicAnsweredMaster.find(item => item._id === setMaster._id) ? 1 : 0)}
                                                            style={{ maxWidth: '150px' }}
                                                            disabled={tonicAnsweredMaster.find(item => item._id === setMaster._id)}
                                                        >
                                                            Start
                                                    </button>
                                                </div>
                                            </div>
                                            {/* <div className='whitespace-normal text-blue-700'>{setMaster.setDesc}</div> */}
                                            {selectedSetId === setMaster._id && (
                                                <div className='bg-gray-200 text-black text-sm'>
                                                    <h2 className='text-blue-600'><strong>{setMaster.setTitle}</strong></h2>
                                                    <p><strong>Target Participants:</strong> {setMaster.setGrade}</p>
                                                    <p><strong>Description:</strong> {setMaster.setDesc}</p>
                                                    <p><strong>Total Questions:</strong> {setMaster.setTotalQuestions}</p>
                                                    <p><strong>Time Limit (In Minutes):</strong> {setMaster.timeLimitInMin}</p>
                                                    <p><strong>Correct Answer Points:</strong> {setMaster.correctAnswerPoints}</p>
                                                    {setMaster.WrongAnswerPoints < 0 ? (
                                                        <p className='text-red-600'><strong>Wrong Answer Points:</strong> {setMaster.WrongAnswerPoints}</p>
                                                    ):(
                                                        <p><strong>Points / Marks will not be Deducted for Wrong Answers!</strong></p>
                                                    )}
                                                    <p><strong>Remarks:</strong> {setMaster.remarks}</p>
                                                    <p><strong>Prizes:</strong> {setMaster.prizes}</p>


                                                    {/* <p><strong>Reference Book:</strong> {setMaster.setRefBookName}</p>
                                                    <p><strong>Author:</strong> {setMaster.setAuthor}</p> */}
                                                    {/* <p><strong>Test Series:</strong> {setMaster.seriesTitle}</p>
                                                    <p><strong>Target Exam:</strong> {setMaster.examTitle}</p>
                                                    <p><strong>Exam Type:</strong> {setMaster.examType}</p> */}
                                                </div>
                                            )}
                                            
                                        </div>
                                    ))
                                )}
                            </div>
                            <h2 className="ml-2 md:ml-0 text-white bg-green-600 rounded p-2 text-lg">My {tonicQueryTitle} Tonic History</h2>
                            <div>
                                {tonicAnsweredSetList && tonicAnsweredSetList.length === 0 ? (
                                    <div className='mt-4 text-xl text-orange-400'>
                                        No Record Found in Your {tonicQueryTitle} Tonic History!
                                    </div>
                                ) : (
                                    sortedTonicAnsweredSetList.map((answeredSet, index) => (
                                        <div key={answeredSet._id} className='bg-white my-4 p-4 text-gray-600 flex flex-col justify-start rounded-md shadow-md'>
                                            <div className='flex'>
                                                <span className='font-m'>{index + 1}. {answeredSet.setTitle},  Date: {formatDateTime(answeredSet.dateAnswered)}</span>
                                                <Tooltip text={"View details"} position={"top"}>
                                                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleTonicAnsweredSetView(answeredSet._id)}>
                                                        <i className="fa-solid fa-eye"></i>
                                                    </span>
                                                </Tooltip>
                                            </div>
                                            {selectedTonicAnsweredSetId === answeredSet._id && (
                                                <div className='bg-gray-200 text-black mt-4 p-4 rounded-md flex flex-col text-sm'>
                                                    <p className='text-blue-600 text-sm font-bold'>{answeredSet.setTitle}</p>
                                                    <p><strong>Date Answered:</strong> {new Date(answeredSet.dateAnswered).toLocaleDateString()}</p>
                                                    <p><strong>Time Limit:</strong> {convertTimeLimit(answeredSet.timeLimit)}</p>
                                                    <p><strong>Time Taken:</strong> {convertTimeTaken(answeredSet.timeTaken)}</p>
                                                    <p><strong>Number of Questions:</strong> {answeredSet.numberOfQuestions}</p>
                                                    <p><strong>Correct Answers:</strong> {answeredSet.correctAnswers}</p>
                                                    {/* <p><strong>Full Marks:</strong> {answeredSet.fullMarks}</p>
                                                    <p><strong>Marks Obtained:</strong> {answeredSet.marksObtained}</p> */}
                                                    {/* <p><strong>Percentage:</strong> {answeredSet.percentage}%</p> */}
                                                    <p><strong>Percentage:</strong></p>
                                                    <div className="progress-container">
                                                        <div className="progress-bar">
                                                            <div className="progress" style={{ width: `${answeredSet.percentage}%` }}>
                                                                {`${answeredSet.percentage}%`}
                                                            </div>
                                                        </div>
                                                    </div>

                                                        {/* TODO To be Displayed When Competition is Over */}
                                                        <div className="pl-4">
                                                            <p className="text-m font-bold text-blue-600 mt-4">Answers:</p>
                                                            {answeredSet.answers.map((answer, index) => (
                                                                <div key={index} className="mt-2">
                                                                    <p><strong>Question {index + 1}:</strong> {answer.questionTitle}</p>
                                                                    <p className={answer.marksObtained <= 0 ? 'text-red-500' : 'text-green-500'}><strong>My Answer:</strong> {answer.userMCQAnswer}</p>
                                                                    <p className='text-blue-700'><strong>Correct Answer:</strong> {answer.mcqCorrectAnswerText}</p>
                                                                    <p className={answer.marksObtained <= 0 ? 'text-red-500' : 'text-green-500'}><strong>Marks Obtained:</strong> {answer.marksObtained}</p>
                                                                    {/* <p><strong>Marks for Correct Answer:</strong> {answer.correctAnswerPoints}</p> */}
                                                                    {/* {answer.isMCQCorrect === 0 && <p><strong>Marks for Wrong Answer:</strong> {answer.wrongAnswerPoints}</p>} */}
                                                                    {answer.remarks && <p><strong>Remarks:</strong> {answer.remarks}</p>}
                                                                    {/* {answer.userShortAnswer && <p><strong>My Short Answer:</strong> {answer.userShortAnswer}</p>} */}
                                                                </div>
                                                            ))}
                                                        </div>
                                                </div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TonicQuiz;
